import { applySpec, prop } from "ramda";
import { getExternalLocalizedLink } from "../../helpers/routingHelpers";

export const Content = applySpec({
  id: prop("id"),
  title: prop("title"),
  type: prop("type"),
  slug: prop("slug_title"),
  images: prop("images"),
  posterWideImage: content => content.images.poster_wide.flatMap(i => i).find(i => i.type === 'poster_wide')?.source,
  link: content => {
    const { type, id, slug_title } = content;
    let prefix = "/watch";

    switch (type) {
      case "artist":
        prefix = "/artist";
        break;
      case "concert":
        prefix = "/concert";
        break;
      case "series":
        prefix = "/series";
        break;
    }

    return getExternalLocalizedLink(`${prefix}/${id}/${slug_title}`);
  }
});